import * as React from 'react';

// Utils
import { useTranslation } from 'react-i18next';
// Constants
// Actions
// Models & Interfaces
// Components
// Styles
import './styles/MobileFilterButtons.scss';
// Images

type Props = React.PropsWithChildren & {
  toggleMobileFilterOverlay(): void;
  showHotelsList?: boolean;
  toggleDisplayHotelList?: () => void;
};

export const MobileFilterButtons: React.FC<Props> = ({ toggleMobileFilterOverlay, children }) => {
  const { t } = useTranslation();

  return (
    <div className="mobile-filter-buttons">
      <button className="button" onClick={toggleMobileFilterOverlay}>
        <i className="material-symbols is--first">filter_list</i>
        {t(`tripsConn.button.filter`)}
      </button>
      {children}
    </div>
  );
};
